import * as dayjs from 'dayjs';

export class CreditCard {
    cardNo: string;
    cardName: string;
    cardHolderName: string;
    ccv: string;
    month: string;
    year: string;

    constructor() {
        this.cardHolderName = '';
        this.cardName = '';
        this.cardNo = '';
        this.ccv = '';
        this.month = dayjs(new Date()).format('MM');
        this.year = dayjs(new Date()).format('YY');
    }
}
